export const FormatOption = [
    { value: 'a4', label: 'A4 8.3 x 11.7 in (210 x 297 mm)' },
    { value: 'legal', label: 'Legal 8.5 x 14.0 in (215.9 x 356.6 mm)' },
    { value: 'letter', label: 'Letter 8.5 x 11 in (215.9 x 279.4 mm)' }
]

export const orientationOption = [
    { value: 'landscape', label: 'Landscape' },
    { value: 'portrait', label: 'Portrait' }
]

export const tableWidthOptions = [
    { value: 'auto', label: 'Auto-fit Columns' },
    { value: 'wrap', label: 'Fixed-width Columns' }
]

export const DAY_SHORT_LABEL: Record<string, string> = {
    Monday: 'Mo', Tuesday: 'Tu', Wednesday: 'We', Thursday: 'Th',
    Friday: 'Fr', Saturday: 'Sa', Sunday: 'Su',
};

const colors = [
    // Basics
    "#000000", "#ffffff", "#ff0000", "#00ff00", "#0000ff",
    // Reds/Pinks
    "#e74c3c", "#c0392b", "#ff6b6b", "#ff4757", "#ff6b81",
    "#e84393", "#fd79a8", "#fab1a0",
    // Oranges/Yellows  
    "#e67e22", "#f39c12", "#f1c40f", "#ffeaa7", "#fdcb6e",
    "#ff7675", "#e17055",
    // Greens
    "#2ecc71", "#27ae60", "#1abc9c", "#16a085", "#00b894",
    "#00cec9", "#55efc4", "#a29bfe",
    // Blues/Purples
    "#3498db", "#2980b9", "#9b59b6", "#8e44ad", "#6c5ce7",
    "#74b9ff", "#0984e3", "#6c5ce7",
    // Grays
    "#95a5a6", "#7f8c8d", "#bdc3c7", "#ecf0f1", "#636e72",
    "#2d3436", "#dfe6e9",
    // Brand-ish
    "#512DA8", "#0d6efd", "#198754", "#dc3545", "#ffc107",
];

export const editorToolbar = [
    [
        {
            header: [1, 2, 3, 4, 5, 6, false]
        }
    ],
    [
        {
            font: ["arial", "comic-sans", "courier-new", "georgia", "helvetica", "lucida", "tahoma", "times-new-roman", "trebuchet", "verdana"]
        }
    ],
    [
        {
            size: ["8px", "11px", "13px", "15px", "16px", "17px", "24px", "36px"]
        }
    ],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
        {
            color: colors
        },
        {
            background: colors
        }
    ],
    [
        {
            list: "ordered"
        },
        {
            list: "bullet"
        },
        {
            list: "check"
        }
    ],
    [
        {
            direction: "rtl"
        },
        {
            align: ["right", "center", "justify", ""]
        }
    ],
]